import type { ComparisonConfig } from './ComparisonPage';

const OPERA_AR: ComparisonConfig = {
  slug: 'hotelstack-vs-opera',
  competitorName: 'Oracle OPERA',
  heroTitle: 'HotelStack.io مقابل Oracle OPERA',
  heroSubtitle: 'Oracle OPERA هو المعيار القديم في الصناعة — تم بناؤه منذ عقود ولا يزال يحمل تعقيدات وأسعار حقبة المؤسسات الكبرى. HotelStack.io يقدم بديلاً حديثاً سحابياً بالكامل مع وحدات أكثر وأسعار أبسط وبدون أعباء بنية تحتية.',
  overviewComparison: [
    { label: 'البنية التقنية', hotelstack: 'SaaS سحابي بالكامل', competitor: 'محلي قديم / سحابي' },
    { label: 'الأسعار', hotelstack: 'يبدأ من $49/شهرياً', competitor: '$500+/شهرياً + تراخيص' },
    { label: 'التنفيذ', hotelstack: 'مجاني — تفعيل خلال 48 ساعة', competitor: 'تنفيذ من 3-6 أشهر' },
    { label: 'إجمالي الوحدات', hotelstack: '36 وحدة مدمجة', competitor: '20+ (تراخيص منفصلة)' },
    { label: 'الأغذية والمشروبات / نقاط البيع', hotelstack: 'مدمج', competitor: 'ترخيص OPERA POS منفصل' },
    { label: 'الشريحة المستهدفة', hotelstack: 'صغيرة إلى مؤسسات كبرى', competitor: 'المؤسسات الكبرى فقط' },
  ],
  featureTable: [
    {
      category: 'نظام إدارة الفنادق الأساسي',
      features: [
        { name: 'إدارة الحجوزات', hotelstack: true, competitor: true },
        { name: 'لوحة الغرف المرئية', hotelstack: true, competitor: true },
        { name: 'معالج التدقيق الليلي', hotelstack: true, competitor: true },
        { name: 'إدارة حساب النزيل', hotelstack: true, competitor: true },
        { name: 'الحجوزات الجماعية', hotelstack: true, competitor: true },
        { name: 'بوابة تسجيل الوصول الإلكتروني', hotelstack: true, competitor: 'إضافة مدفوعة' },
      ],
    },
    {
      category: 'السحابة وإمكانية الوصول',
      features: [
        { name: 'سحابي بالكامل', hotelstack: true, competitor: 'هجين' },
        { name: 'بدون صيانة خوادم', hotelstack: true, competitor: false },
        { name: 'مزامنة فورية متعددة الأجهزة', hotelstack: true, competitor: 'محدود' },
        { name: 'واجهة حديثة متجاوبة', hotelstack: true, competitor: false },
        { name: 'تحديثات تلقائية', hotelstack: true, competitor: false },
        { name: 'لا حاجة لفريق تقنية معلومات', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'إدارة الإيرادات',
      features: [
        { name: 'قواعد التسعير الديناميكي', hotelstack: true, competitor: true },
        { name: 'محاكي الإيرادات الافتراضي', hotelstack: true, competitor: false },
        { name: 'مراقبة أسعار المنافسين', hotelstack: true, competitor: 'عبر Oracle BI' },
        { name: 'التنبؤ بالطلب', hotelstack: true, competitor: true },
        { name: 'تحليلات RevPAR', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'الأغذية والمشروبات والعمليات',
      features: [
        { name: 'محطة نقاط البيع', hotelstack: true, competitor: 'ترخيص منفصل' },
        { name: 'وحدة خدمة الغرف', hotelstack: true, competitor: 'ترخيص منفصل' },
        { name: 'نظام عرض المطبخ', hotelstack: true, competitor: false },
        { name: 'جدولة الموظفين', hotelstack: true, competitor: false },
        { name: 'أوامر عمل الصيانة', hotelstack: true, competitor: 'عبر التكامل' },
      ],
    },
    {
      category: 'التكلفة والتفعيل',
      features: [
        { name: 'تفعيل مجاني', hotelstack: true, competitor: false },
        { name: 'ترحيل بيانات مجاني', hotelstack: true, competitor: false },
        { name: 'بدون تكاليف خوادم', hotelstack: true, competitor: false },
        { name: 'بدون رسوم تراخيص', hotelstack: true, competitor: false },
        { name: 'تسعير بالعملة المحلية', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'المرونة والعمل دون اتصال',
      features: [
        { name: 'تطبيق ويب تقدمي يعمل دون اتصال', hotelstack: true, competitor: false },
        { name: 'قائمة انتظار التعديلات دون اتصال', hotelstack: true, competitor: false },
        { name: 'مزامنة خلفية عند إعادة الاتصال', hotelstack: true, competitor: false },
        { name: 'تسوية تراعي التعارضات', hotelstack: true, competitor: false },
        { name: 'مكتب استقبال قابل للتثبيت', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'مبيعات الشركات والمجموعات',
      features: [
        { name: 'إدارة أسعار الشركات', hotelstack: true, competitor: 'إضافة مدفوعة' },
        { name: 'حجز المجموعات مع قوائم الغرف', hotelstack: true, competitor: 'إضافة مدفوعة' },
        { name: 'تقارير أعمار الذمم والإنتاج', hotelstack: true, competitor: 'إضافة مدفوعة' },
        { name: 'حجوزات المطاعم', hotelstack: true, competitor: 'إضافة Micros' },
      ],
    },
    {
      category: 'الموظفون والموارد البشرية',
      features: [
        { name: 'دليل الموظفين وجدولة المناوبات', hotelstack: true, competitor: 'عبر التكامل' },
        { name: 'معالجة الرواتب', hotelstack: true, competitor: false },
        { name: 'الإجازات والحضور', hotelstack: true, competitor: false },
        { name: 'تحليلات الأداء', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$500+',
    hotelstackNote: 'جميع الـ 36 وحدة مشمولة. بدون رسوم تراخيص. بدون تكاليف خوادم. تفعيل وترحيل مجاني. تسعير محلي بـ EUR و GBP و AED و INR و THB.',
    competitorNote: 'ترخيص مؤسسي من $500+/شهرياً لكل فندق. تراخيص منفصلة لـ POS و S&C و OCRM. رسوم تنفيذ من $50,000+. خوادم محلية مطلوبة للإصدار الكلاسيكي.',
  },
  advantages: [
    'تكلفة ملكية إجمالية أقل بنسبة تتجاوز 90% — بدون رسوم تراخيص أو تكاليف خوادم أو رسوم تنفيذ',
    'ابدأ العمل خلال 48 ساعة مقابل جدول تنفيذ OPERA من 3-6 أشهر',
    'واجهة سحابية حديثة يمكن الوصول إليها من أي جهاز — لا حاجة لتطبيق سطح مكتب',
    'جميع الـ 36 وحدة مشمولة في اشتراك واحد مقابل تراخيص OPERA المنفصلة',
    'بدون بنية تحتية تقنية — لا خوادم ولا تصحيحات ولا حاجة لمدير قواعد بيانات Oracle',
    'الأغذية والمشروبات ونقاط البيع مدمجة بدون تكلفة إضافية مقابل ترخيص OPERA POS المنفصل',
    'تسعير محلي بـ 6 عملات حتى تدفع الفنادق بعملتها المحلية',
    'ترحيل بيانات مجاني من OPERA مع فريق دعم مخصص',
  ],
  verdict: {
    title: 'حكمنا',
    summary: 'Oracle OPERA كان المعيار الصناعي لعقود ويبقى خياراً جيداً لسلاسل المؤسسات الكبرى ذات البنية التحتية الحالية لـ Oracle. لكن بالنسبة لغالبية الفنادق، HotelStack.io يقدم وحدات أكثر وتجربة مستخدم أفضل وتكاليف أقل بشكل كبير بدون دورات التنفيذ الطويلة وأعباء الخوادم والتراخيص المعقدة التي يتطلبها OPERA.',
    bestFor: [
      'الفنادق الراغبة في التخلص من تراخيص Oracle المكلفة وتكاليف البنية التحتية',
      'المنشآت المتعبة من بطء تنفيذ وتحديث OPERA',
      'الفنادق التي تحتاج واجهة سحابية حديثة بدون الاعتماد على تطبيقات سطح المكتب',
      'المنشآت الصغيرة والمتوسطة التي لا تستطيع تحمل خطط OPERA المؤسسية',
      'المنشآت الراغبة في الحصول على جميع الوحدات بدون رسوم تراخيص منفصلة',
    ],
  },
  faqItems: [
    { question: 'هل يمكنني الترحيل من Oracle OPERA إلى HotelStack.io؟', answer: 'نعم. فريق الترحيل لدينا متخصص في عمليات الانتقال من OPERA إلى HotelStack. نقوم باستيراد ملفات النزلاء وسجل الحجوزات ورموز الأسعار وتكوينات الغرف وحجوزات المجموعات. الترحيل مجاني ويكتمل عادةً خلال 48-72 ساعة بدون أي توقف.' },
    { question: 'هل يدعم HotelStack.io نفس التكاملات التي يدعمها OPERA؟', answer: 'HotelStack.io يتصل بأكثر من 100 وكالة سفر إلكترونية و GDS عبر Amadeus و Sabre وبوابات الدفع الرئيسية. سوق التكاملات لدينا يغطي نفس المنظومة. كما نوفر API مفتوح للتكاملات المخصصة.' },
    { question: 'كيف يقارن HotelStack.io مع OPERA Cloud؟', answer: 'OPERA Cloud هو تحديث Oracle لمنتجها القديم. HotelStack.io بُني سحابياً من اليوم الأول بتقنيات حديثة. نقدم وحدات أكثر (36 مقابل قاعدة OPERA Cloud) وأسعار أبسط وتفعيل أسرع وبدون الاعتماد على بنية Oracle التحتية.' },
    { question: 'هل HotelStack.io مناسب لسلاسل الفنادق الكبيرة التي تستخدم OPERA حالياً؟', answer: 'نعم. خطط السلاسل والمؤسسات لدينا تدعم إدارة متعددة المنشآت مع تحليلات مركزية وتوزيع أسعار ومعايير العلامة التجارية — نفس القدرات التي تبقي السلاسل الكبيرة على OPERA، بجزء من التكلفة.' },
  ],
};

const RMS_CLOUD_AR: ComparisonConfig = {
  slug: 'hotelstack-vs-rms-cloud',
  competitorName: 'RMS Cloud',
  heroTitle: 'HotelStack.io مقابل RMS Cloud',
  heroSubtitle: 'RMS Cloud يخدم سوق الضيافة في منطقة آسيا والمحيط الهادئ بأساسيات PMS قوية. HotelStack.io يتوسع بـ 36 وحدة وتسعير متعدد العملات عالمياً وأغذية ومشروبات/نقاط بيع مدمجة وإدارة إيرادات متقدمة — كل ذلك بسعر أقل.',
  overviewComparison: [
    { label: 'إجمالي الوحدات', hotelstack: '36 وحدة متكاملة', competitor: '12+ وحدة' },
    { label: 'الأسعار', hotelstack: 'يبدأ من $49/شهرياً', competitor: 'يبدأ من $80+/شهرياً' },
    { label: 'الانتشار العالمي', hotelstack: '40+ دولة', competitor: 'أساساً آسيا والمحيط الهادئ' },
    { label: 'الأغذية والمشروبات / نقاط البيع', hotelstack: 'مدمج', competitor: 'غير متاح' },
    { label: 'إدارة الإيرادات', hotelstack: 'متقدمة (مدمجة)', competitor: 'أساسية' },
    { label: 'محرك الحجز', hotelstack: 'BookMyRoom.io (مجاني)', competitor: 'أداة حجز بسيطة' },
  ],
  featureTable: [
    {
      category: 'نظام إدارة الفنادق الأساسي',
      features: [
        { name: 'PMS سحابي', hotelstack: true, competitor: true },
        { name: 'لوحة الغرف المرئية', hotelstack: true, competitor: true },
        { name: 'إدارة الحجوزات', hotelstack: true, competitor: true },
        { name: 'معالج التدقيق الليلي', hotelstack: true, competitor: true },
        { name: 'الحجوزات الجماعية', hotelstack: true, competitor: true },
        { name: 'بوابة تسجيل الوصول الإلكتروني', hotelstack: true, competitor: 'محدود' },
      ],
    },
    {
      category: 'الإيرادات والتوزيع',
      features: [
        { name: 'مدير القنوات (100+ OTA)', hotelstack: true, competitor: 'عدد محدود من OTA' },
        { name: 'قواعد التسعير الديناميكي', hotelstack: true, competitor: false },
        { name: 'مراقبة أسعار المنافسين', hotelstack: true, competitor: false },
        { name: 'محاكي الإيرادات الافتراضي', hotelstack: true, competitor: false },
        { name: 'التنبؤ بالطلب', hotelstack: true, competitor: 'أساسي' },
        { name: 'تحليلات RevPAR', hotelstack: true, competitor: 'أساسي' },
      ],
    },
    {
      category: 'إدارة النزلاء',
      features: [
        { name: 'ملفات نزلاء شاملة 360 درجة', hotelstack: true, competitor: 'أساسي' },
        { name: 'إدارة برنامج الولاء', hotelstack: true, competitor: false },
        { name: 'أتمتة التواصل مع النزلاء', hotelstack: true, competitor: 'محدود' },
        { name: 'تحليلات إنفاق النزلاء', hotelstack: true, competitor: false },
        { name: 'رفع والتحقق من الهوية', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'الأغذية والمشروبات والعمليات',
      features: [
        { name: 'محطة نقاط البيع', hotelstack: true, competitor: false },
        { name: 'وحدة خدمة الغرف', hotelstack: true, competitor: false },
        { name: 'نظام عرض المطبخ', hotelstack: true, competitor: false },
        { name: 'إدارة التدبير المنزلي', hotelstack: true, competitor: true },
        { name: 'أوامر عمل الصيانة', hotelstack: true, competitor: false },
        { name: 'جدولة الموظفين والرواتب', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'تعدد المنشآت والامتثال',
      features: [
        { name: 'لوحة تحكم السلسلة', hotelstack: true, competitor: true },
        { name: 'تحليلات عبر المنشآت', hotelstack: true, competitor: 'محدود' },
        { name: 'فوترة متعددة العملات', hotelstack: true, competitor: 'تركيز على AUD' },
        { name: 'الامتثال الضريبي الإقليمي', hotelstack: true, competitor: 'آسيا والمحيط الهادئ فقط' },
        { name: 'حماية بيانات GDPR', hotelstack: true, competitor: 'محدود' },
      ],
    },
    {
      category: 'المرونة والعمل دون اتصال',
      features: [
        { name: 'تطبيق ويب تقدمي يعمل دون اتصال', hotelstack: true, competitor: false },
        { name: 'قائمة انتظار التعديلات دون اتصال', hotelstack: true, competitor: false },
        { name: 'مزامنة خلفية عند إعادة الاتصال', hotelstack: true, competitor: false },
        { name: 'تسوية تراعي التعارضات', hotelstack: true, competitor: false },
        { name: 'مكتب استقبال قابل للتثبيت', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'مبيعات الشركات والمجموعات',
      features: [
        { name: 'إدارة أسعار الشركات', hotelstack: true, competitor: false },
        { name: 'حجز المجموعات مع قوائم الغرف', hotelstack: true, competitor: 'محدود' },
        { name: 'تقارير أعمار الذمم والإنتاج', hotelstack: true, competitor: false },
        { name: 'حجوزات المطاعم', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'الموظفون والموارد البشرية',
      features: [
        { name: 'دليل الموظفين وجدولة المناوبات', hotelstack: true, competitor: false },
        { name: 'معالجة الرواتب', hotelstack: true, competitor: false },
        { name: 'الإجازات والحضور', hotelstack: true, competitor: false },
        { name: 'تحليلات الأداء', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$80+',
    hotelstackNote: 'جميع الـ 36 وحدة مشمولة. تسعير محلي بـ EUR و GBP و AED و INR و THB. تفعيل وترحيل بيانات مجاني.',
    competitorNote: 'تسعير بالدولار الأسترالي من $80+/شهرياً. رسوم إضافية لمدير القنوات والميزات المتقدمة. دعم أساساً لمنطقة آسيا والمحيط الهادئ.',
  },
  advantages: [
    'ما يقارب ثلاثة أضعاف الوحدات (36 مقابل 12+) مع جميع الميزات مشمولة بسعر أقل',
    'تغطية عالمية في 40+ دولة مقابل تركيز RMS Cloud على أسواق آسيا والمحيط الهادئ',
    'وحدة أغذية ومشروبات كاملة مع محطة نقاط البيع وخدمة الغرف وإدارة المطبخ',
    'إدارة إيرادات متقدمة مع تسعير ديناميكي وتنبؤ ومحاكيات',
    'اتصال أقوى بالقنوات مع 100+ OTA و GDS عبر Amadeus و Sabre',
    'إدارة الموظفين مع الجدولة والرواتب والحضور وتتبع الأداء',
    'فوترة متعددة العملات بـ 6 عملات مقابل التسعير الأسترالي أساساً',
    'تفعيل وترحيل بيانات مجاني مع دعم مخصص على مدار الساعة',
  ],
  verdict: {
    title: 'حكمنا',
    summary: 'RMS Cloud هو نظام PMS قوي لمنشآت آسيا والمحيط الهادئ بأساسيات متينة لإدارة الإقامة. HotelStack.io يقدم حلاً أشمل بـ 36 وحدة وانتشار عالمي وإدارة إيرادات متقدمة وقدرات كاملة للأغذية والمشروبات/نقاط البيع — كل ذلك بسعر أقل. للمنشآت التي تتطلع لما هو أبعد من PMS الأساسي نحو إدارة عمليات فندقية شاملة، HotelStack.io هو الخيار الأقوى.',
    bestFor: [
      'الفنادق الراغبة في منصة شاملة متكاملة تتجاوز PMS الأساسي',
      'المنشآت التي تحتاج أغذية ومشروبات ونقاط بيع وإدارة مطبخ مدمجة',
      'الفنادق المتوسعة خارج آسيا والمحيط الهادئ التي تحتاج امتثال وتوزيع عالمي',
      'المنشآت الراغبة في إدارة إيرادات متقدمة وتسعير ديناميكي',
      'سلاسل متعددة المنشآت تحتاج تحليلات مركزية عبر منشآت عالمية',
    ],
  },
  faqItems: [
    { question: 'هل يمكنني الترحيل من RMS Cloud إلى HotelStack.io؟', answer: 'نعم. فريق الترحيل لدينا يتولى النقل الكامل للبيانات من RMS Cloud بما في ذلك ملفات النزلاء وسجل الحجوزات وتكوينات الأسعار وإعدادات الغرف. الترحيل مجاني ويكتمل عادةً خلال 48 ساعة بدون أي توقف.' },
    { question: 'هل يعمل HotelStack.io جيداً للفنادق الأسترالية وفنادق آسيا والمحيط الهادئ؟', answer: 'بالتأكيد. HotelStack.io يدعم الفوترة متعددة العملات بما في ذلك AUD والامتثال الضريبي الإقليمي لأسواق آسيا والمحيط الهادئ والاتصال بوكالات السفر الإلكترونية المحلية. العديد من منشآتنا في المنطقة انتقلت من RMS Cloud للوحدات الإضافية والانتشار العالمي.' },
    { question: 'كيف يقارن تسعير HotelStack.io مع RMS Cloud؟', answer: 'HotelStack.io يبدأ من $49/شهرياً مع جميع الـ 36 وحدة مشمولة وتسعير محلي بـ 6 عملات. RMS Cloud يبدأ من حوالي $80+/شهرياً بالدولار الأسترالي مع وحدات أقل ورسوم إضافية لإدارة القنوات والميزات المتقدمة.' },
    { question: 'هل يدعم HotelStack.io المنتجعات والمخيمات مثل RMS Cloud؟', answer: 'HotelStack.io مصمم لجميع أنواع الإقامة بما في ذلك الفنادق والمنتجعات والنُزل والمنشآت البوتيكية والشقق الفندقية. بينما لدى RMS Cloud ميزات خاصة بالمنتجعات الترفيهية، مرونة تكوين HotelStack.io تدعم نماذج إقامة متنوعة.' },
  ],
};

export const COMPARISON_AR_P2: Record<string, ComparisonConfig> = {
  'hotelstack-vs-opera': OPERA_AR,
  'hotelstack-vs-rms-cloud': RMS_CLOUD_AR,
};
